let keyCount = 0;

export function generateBlockId(): number {
    return keyCount++;
}